<div fxShow.lt-md="false" fxLayout="row" class="cardColumnHeaderPositon">
<span class="cardColumnHeaderText" *ngFor="let item of cardHeaders" [attr.fxFlex]="item.width">{{item.label | translate}} </span>
</div>